module.exports = __webpack_public_path__ + "img/sign.cae1e2ea.png";